'use strict';

const MAX_SUGGESTIONS_COUNT = 10;

var sharedState = require('./sharedState');
const $cache = sharedState.$cache;

var commonFeatures = require('./commonFeatures');

const init = () => {

    sharedState.debug('airportsFeatures', 'init');

    // handle search airport
    $cache.tripDeparture.add($cache.tripDestination).on('click', (e) => {
        e.preventDefault();

        if (!window.app.isMobile()) {
            sharedState.debug('Ignore click on search inputs in Desktop env');
            return;
        }

        // Clear popup
        $cache.popupSearchAirport.find('input').val('');
        $cache.popupSearchAirportResults.empty();
        $cache.popupSearchAirport.removeClass('tripDeparture tripDestination');

        // Show popup
        const mode = $(e.target).attr('id');
        $cache.popupSearchAirport.addClass(`visible ${mode}`);
    });

    $cache.tripDeparture.add($cache.tripDestination).on('input', (e) => {
        e.preventDefault();

        if (window.app.isMobile()) {
            sharedState.debug('Ignore input on search inputs in Mobile env');
            return;
        }

        if (handleAirportSearchInput(e)) {
            // Show popup
            const mode = $(e.target).attr('id');
            $cache.popupSearchAirport.addClass(`visible ${mode}`).attr('data-mode', mode);
        }
    });

    $cache.tripDeparture.add($cache.tripDestination).on('focusout', (e) => {
        e.preventDefault();

        if (window.app.isMobile()) {
            sharedState.debug('Ignore focusout on search inputs in Mobile env');
            return;
        }

        setTimeout(() => {
            $cache.popupSearchAirport.removeClass('tripDeparture tripDestination visible');
            fillAirportInput($(e.currentTarget));
        }, 300);
    });

    $cache.tripDeparture.add($cache.tripDestination).on('focus', (e) => {
        e.preventDefault();

        if (window.app.isMobile()) {
            sharedState.debug('Ignore focus on search inputs in Mobile env');
            return;
        }

        const mode = $(e.target).attr('id');
        if ($cache.popupSearchAirportResults.children().length > 0 && $cache.popupSearchAirport.attr('data-mode') === mode) {
            // Show popup
            $cache.popupSearchAirport.addClass(`visible ${mode}`);
        }
    });

    // Get airports departure list on init
    getDepartureAirports();

    // Init Popup inner features
    handleAirportsPopupBehavior();
};

const getDepartureAirports = () => {
    if (sharedState.airports.departure.length > 0) {
        sharedState.debug('getDepartureAirports ... Skipped! Airports list already available', 'sharedState.airports.departure.length', sharedState.airports.departure.length);
        return;
    }

    const endpoints = $cache.mainWrapper.data('airports-endpoints');
    if (!endpoints) {
        sharedState.debug('Unable to get airports endpoints. Aborting ....');
        return;
    }
    let endpoint =  endpoints.departure;

    sharedState.debug('getDepartureAirports', 'endpoint', endpoint);

    $.ajax({
        url: endpoint,
        type: 'get',
        dataType: 'json',
        /**
         * @param {*} data Response from server
         * Success response.
         */
        success: function (data) {
            sharedState.debug('searchAirport', 'ajax', 'data', data);
            if (data.result && data.result.length > 0) {
                sharedState.airports.departure = data.result;
            }
        },
        /**
         * Error Handler
         */
        error: function (err) {
            console.error('getDepartureAirports', 'error', err);
        }
    });
};

const getDestinationAirports = (airportCode) => {
    if (airportCode && sharedState.airports.destination[airportCode] && sharedState.airports.destination[airportCode].length > 0) {
        sharedState.debug('getDestinationAirports ... Skipped! Airports list already available', `sharedState.airports.destination[${airportCode}].length`, sharedState.airports.departure.length);
        return;
    }

    const endpoints = $cache.mainWrapper.data('airports-endpoints');
    if (!endpoints) {
        sharedState.debug('Unable to get airports endpoints. Aborting ....');
        return;
    }
    let endpoint = `${endpoints.destination}?departure=${airportCode}`;

    sharedState.debug('getDestinationAirports', 'endpoint', endpoint);

    $.ajax({
        url: endpoint,
        type: 'get',
        dataType: 'json',
        /**
         * @param {*} data Response from server
         * Success response.
         */
        success: function (data) {
            sharedState.debug('searchAirport', 'ajax', 'data', data);
            if (data.result && data.result.length > 0) {
                sharedState.airports.destination[airportCode] = data.result;
            }
        },
        /**
         * Error Handler
         */
        error: function (err) {
            console.error('getDestinationAirports', 'error', err);
        }
    });
};

const handleAirportSearchInput = (e) => {
    $cache.popupSearchAirportResults.empty();

    let searchTerm = $(e.currentTarget).val();
    if (searchTerm.length < 3) {
        return;
    }

    let matchingAirports = searchAirport(searchTerm);

    sharedState.debug('handleAirportsPopupBehavior', 'searchTerm', searchTerm, 'matchingAirports', matchingAirports);

    if (matchingAirports.length === 0) {
        return;
    }

    matchingAirports.forEach((item) => {
        let $item = $cache.airportItemToClone.clone();

        $item.find('.airport-result-item__city').text(item.city);
        $item.find('.airport-result-item__name').text(item.airport);
        $item.find('.airport-result-item__code').text(`(${item.code.toUpperCase()})`);

        $item.attr('data-airport', JSON.stringify(item));

        $cache.popupSearchAirportResults.append($item);
    });

    return true;
};

const fillAirportInput = ($input) => {
    let airportData = null;
    try {
        airportData = JSON.parse($input.attr('data-airport'));
    } catch (error) {
        // Nothing to do ...
    }
    if (airportData) {
        $input.val(`${airportData.city} (${airportData.code})`);
    } else {
        $input.val('');
        $cache.popupSearchAirportResults.empty();
    }

    // Check duplication
    let $otherAirport = $('input[data-airport]').not($input);
    let otherAirportData = null;
    try {
        otherAirportData = JSON.parse($otherAirport.attr('data-airport'));
    } catch (error) {
        // Nothing to do ...
    }

    if (otherAirportData && otherAirportData.code === airportData.code) {
        $otherAirport.val('');
    }
};

const searchAirport = (searchTerm, from) => {
    let airports = from ? sharedState.airports.destination[from] : sharedState.airports.departure;

    if (!airports || airports.length === 0) {
        sharedState.debug('searchAirport', 'empty airports list');
        return;
    }

    let results = [];
    let preparedSearchTerm = searchTerm.toLowerCase();

    for (let i = 0; i < airports.length && results.length < MAX_SUGGESTIONS_COUNT; i++) {
        const item = airports[i];
        if (item.code.toLowerCase().startsWith(preparedSearchTerm) || item.airport.toLowerCase().startsWith(preparedSearchTerm) || item.city.toLowerCase().startsWith(preparedSearchTerm)) {
            results.push(item);
        }
    }

    return results;
};

const handleAirportsPopupBehavior = () => {
    // Handle Close button
    $cache.popupSearchAirport.on('click', '.popup-search-airport__close', () => {
        $cache.popupSearchAirport.removeClass('visible');
    });

    // Handle input changes
    $cache.popupSearchAirport.on('input', 'input', handleAirportSearchInput);

    // Handle select element
    $cache.popupSearchAirport.on('click', '.airport-result-item', (e) => {
        // Get airport data
        let $airport = $(e.currentTarget);
        let airportData = JSON.parse($airport.attr('data-airport'));

        if ($cache.popupSearchAirport.hasClass('tripDeparture')) {
            // Update departure input
            $cache.tripDeparture.attr('data-airport', JSON.stringify(airportData));
            fillAirportInput($cache.tripDeparture);

            // Get destination airports list
            getDestinationAirports(airportData.code);
            $cache.tripDeparture.closest('.form-group').removeClass('empty-input');
        } else {
            // Update departure input
            $cache.tripDestination.attr('data-airport', JSON.stringify(airportData));
            fillAirportInput($cache.tripDestination);
            $cache.tripDestination.closest('.form-group').removeClass('empty-input');
        }

        // Close popup
        $cache.popupSearchAirport.removeClass('visible');

        // Check form validity
        $cache.mainWrapper.trigger('form:validityCheck');
    });
};

const checkInputsValidity = (skipInvalidate) => {
    let isDepartureValid = $cache.tripDeparture.val().length > 0;
    let isDestinationValid = $cache.tripDestination.val().length > 0;

    if (isDepartureValid) {
        $cache.tripDeparture.closest('.ita-input').removeClass('invalid');
    } else if (!skipInvalidate) {
        $cache.tripDeparture.closest('.ita-input').addClass('invalid');
    }

    if (isDestinationValid) {
        $cache.tripDestination.closest('.ita-input').removeClass('invalid');
    } else if (!skipInvalidate) {
        $cache.tripDestination.closest('.ita-input').addClass('invalid');
    }

    return isDepartureValid && isDestinationValid;
};

module.exports = {
    init: init,
    fillAirportInput: fillAirportInput,
    checkInputsValidity: checkInputsValidity,
}